<fc-search-many-input
  [label]="'LOCATION.LABEL' | translate"
  [control]="control"
  [showSearchIcon]="showSearchIcon"
  [desiredStyle]="desiredStyle"
  [search]="search"
  [displayWith]="displayWith"
></fc-search-many-input>
